import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProduct = async () => {
  const { data } = await apiClient.get("/product");
  return data;
};

export const fetchReviews = async () => {
  const { data } = await apiClient.get("/reviews");
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await apiClient.post("/orders", payload);
  return data;
};

export const trackOrder = async (q) => {
  const { data } = await apiClient.get(`/orders/track`, { params: { q } });
  return data;
};

export const listOrders = async () => {
  const { data } = await apiClient.get("/orders");
  return data;
};
